var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FForm',{attrs:{"route":"models","title":"Model","columns":"1","url":_vm.value ? ('/models/' + _vm.$route.params.season_id + '/' + _vm.value.id) : null,"schema":[
    {
      component: 'FInput',
      key: 'name',
      label: 'Name',
      required: true
    },
    {
      component: 'FSelect',
      key: 'season_id',
      label: 'Season',
      items: _vm.seasons
    }
  ]},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})}
var staticRenderFns = []

export { render, staticRenderFns }